/**
 * @generated SignedSource<<4f39e3c5874c5c6f41ea899768127f2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeatureFlag_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"usePermissionFragment">;
  readonly " $fragmentType": "FeatureFlag_user";
};
export type FeatureFlag_user$key = {
  readonly " $data"?: FeatureFlag_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeatureFlag_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeatureFlag_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "usePermissionFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdmin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allRoles",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Company",
          "kind": "LinkedField",
          "name": "company",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "features",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2183ff8d8f62c501278a90a649287977";

export default node;
